import label from "@/lang/StaticLabels.js";

// PHAMYAR Router  - همیار -----------------------------------------------
let routeItems = {
  path: "PHAMYAR",
  name: "PHAMYAR",
  component: {
    render(c) {
      return c("router-view");
    },
  },
  // با کلیک روی ماژول، داشبورد همان ماژول پیش‌فرض باز می‌شود
  redirect: { name: "PHAMYARDashboard" },
  children: [
    {
      path: "dashboard",
      name: "PHAMYARDashboard",
      meta: {
        label: label.page.dashboard + " " + label.modules.phamyar,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/phamyar/Dashboard.vue"),
    },

    // Base Information  -----------------------------------------------
    {
      path: "goal",
      name: "PHAMYARGoal",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "goal/list",
      children: [
        {
          path: "list",
          name: "PHAMYARGoalList",
          component: () => import("@/views/modules/phamyar/base/goal"),
          meta: {
            label: label.page.goals,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PHAMYARAddGoal",
          component: () => import("@/views/modules/phamyar/base/goal/Info"),
          meta: {
            label: label.page.addGoal,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PHAMYAREditGoal",
          component: () => import("@/views/modules/phamyar/base/goal/Info"),
          meta: {
            label: label.page.editGoal,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "goalUser",
      name: "PHAMYARGoalUser",
      meta: {
        label: label.page.goalUser,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/phamyar/base/goalUser"),
    },
    {
      path: "goalSchedule",
      name: "PHAMYARGoalSchedule",
      meta: {
        label: label.page.goalSchedule,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/phamyar/base/goalSchedule"),
    },
    {
      path: "taskCategory",
      name: "PHAMYARTaskCategory",
      meta: {
        label: label.page.taskCategory,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/phamyar/base/taskCategory"),
    },

    {
      path: "noteCategory",
      name: "PHAMYARNoteCategory",
      meta: {
        label: label.page.noteCategory,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/phamyar/base/noteCategory"),
    },

    {
      path: "noteSubject",
      name: "PHAMYARNoteSubject",
      meta: {
        label: label.page.noteSubject,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/phamyar/base/noteSubject"),
    },

    {
      path: "callCategory",
      name: "PHAMYARCallCategory",
      meta: {
        label: label.page.callCategory,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/phamyar/base/callCategory"),
    },

    {
      path: "callSubject",
      name: "PHAMYARCallSubject",
      meta: {
        label: label.page.callSubject,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/phamyar/base/callSubject"),
    },

    {
      path: "setting",
      name: "PHAMYARSetting",
      meta: {
        label: label.page.settings,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/phamyar/base/setting"),
    },

    {
      path: "serviceSupportSubject",
      name: "PHAMYARServiceSupportSubject",
      meta: {
        label: label.page.serviceSupportSubject,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/phamyar/base/serviceSupportSubject"),
    },

    {
      path: "requestType",
      name: "PHAMYARRequestType",
      meta: {
        label: label.page.hamyarRequestType,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/phamyar/base/requestType"),
    },

    {
      path: "projectType",
      name: "PHAMYARProjectType",
      meta: {
        label: label.page.hamyarProjectType,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/phamyar/base/projectType"),
    },

    {
      path: "workDescription",
      name: "PHAMYARWorkDescription",
      meta: {
        label: label.page.workDescription,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/phamyar/base/workDescription"),
    },

    // Operation  -----------------------------------------------
    {
      path: "workCalendar",
      name: "PHAMYARWorkCalendar",
      meta: {
        label: label.page.workCalendar,
        requiresAuth: true,
      },
      component: () =>
        import("@/views/modules/phamyar/operation/workCalendar"),
    },

    {
      path: "tasks",
      name: "PHAMYARTask",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "task/list",
      children: [
        {
          path: "list",
          name: "PHAMYARTaskList",
          component: () => import("@/views/modules/phamyar/operation/task"),
          meta: {
            label: label.page.tasks,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PHAMYARAddTask",
          component: () =>
            import("@/views/modules/phamyar/operation/task/AddEdit"),
          meta: {
            label: label.page.addTask,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PHAMYAREditTask",
          component: () =>
            import("@/views/modules/phamyar/operation/task/AddEdit"),
          meta: {
            label: label.page.editTask,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "messages",
      name: "PHAMYARMessage",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "message/list",
      children: [
        {
          path: "list",
          name: "PHAMYARMessageList",
          component: () => import("@/views/modules/phamyar/operation/message"),
          meta: {
            label: label.page.messages,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PHAMYARAddMessage",
          component: () =>
            import("@/views/modules/phamyar/operation/message/AddEdit"),
          meta: {
            label: label.page.addMessage,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PHAMYAREditMessage",
          component: () =>
            import("@/views/modules/phamyar/operation/message/AddEdit"),
          meta: {
            label: label.page.editMessage,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "notes",
      name: "PHAMYARNoteList",
      meta: {
        label: label.page.notes,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/phamyar/operation/notes"),
    },
    {
      path: "project",
      name: "PHAMYARProject",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "project/list",
      children: [
        {
          path: "list",
          name: "PHAMYARProjectList",
          component: () => import("@/views/modules/phamyar/operation/project"),
          meta: {
            label: label.page.projects,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PHAMYAREditProject",
          component: () =>
            import("@/views/modules/phamyar/operation/project/Info"),
          meta: {
            label: label.page.editProject,
            requiresAuth: true,
          },
        },
      ],
    },
    {
      path: "requests",
      name: "PHAMYARRequestList",
      meta: {
        label: label.page.requests,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/phamyar/operation/request"),
    },
    {
      path: "calls",
      name: "PHAMYARCallList",
      meta: {
        label: label.page.calls,
        requiresAuth: true,
      },
      component: () => import("@/views/modules/phamyar/operation/call"),
    },
    {
      path: "meeting",
      name: "PHAMYARMeeting",
      component: {
        render(c) {
          return c("router-view");
        },
      },
      redirect: "meeting/list",
      children: [
        {
          path: "list",
          name: "PHAMYARMeetingList",
          component: () => import("@/views/modules/phamyar/operation/meeting"),
          meta: {
            label: label.page.meeting,
            requiresAuth: true,
          },
        },
        {
          path: "add",
          name: "PHAMYARAddMeeting",
          component: () =>
            import("@/views/modules/phamyar/operation/meeting/AddEdit"),
          meta: {
            label: label.page.addMeeting,
            requiresAuth: true,
          },
        },
        {
          path: "edit/:id",
          name: "PHAMYAREditMeeting",
          component: () =>
            import("@/views/modules/phamyar/operation/meeting/AddEdit"),
          meta: {
            label: label.page.editMeeting,
            requiresAuth: true,
          },
        },
      ],
    },

  ],
};

export default routeItems;
